class Modal {
  constructor(el, type) {
    this.el = el;
    this.openButtons = document.querySelectorAll(`[data-modal-open="${type}"]`);
    this.closeButtons = document.querySelectorAll(`[data-modal-close="${type}"]`);
    this.toggleButtons = document.querySelectorAll(`[data-modal-toggle="${type}"]`);
    this.body = document.body;
    this.activeClass = 'active';

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);

    this.bindEventListeners();
  }

  bindEventListeners() {
    for(let i = 0; i < this.openButtons.length; i++) {
      this.openButtons[i].addEventListener('click', this.open);
    }

    for(let i = 0; i < this.closeButtons.length; i++) {
      this.closeButtons[i].addEventListener('click', this.close);
    }

    for(let i = 0; i < this.toggleButtons.length; i++) {
      this.toggleButtons[i].addEventListener('click', this.toggle);
    }
  }

  open() {
    this.el.classList.add(this.activeClass);
    this.body.classList.add('no-scroll');
  }

  close() {
    this.el.classList.remove(this.activeClass);
    this.body.classList.remove('no-scroll');
  }

  toggle() {
    this.el.classList.contains(this.activeClass) ? 
      this.close() : this.open();
  }
}

export default Modal;